export default __webpack_public_path__ + "images/9e03cdc5e6ee64fa2a823b22b1820e5a-trash.svg";